/* sb-dc-catlist.js — 갤러리 사이드바의 카테고리 목록을 관리자 설정대로 맞춘다.
   2026-09-05 신규, 2026-09-10 관리자 설정 연동.

   원래 이 파일은 HIDE = ['Custom Banners', 'Best Sellers'] 를 박아 둔 목록이었다.
   그 두 칸은 라이브러리를 다시 쌓는 동안 쓴 선반이지 손님이 찾는 이름은 아니라서
   가리라는 지시였다.

   보고 (2026-09-10, 확인됨)
   ----------------------
   관리자 «순서» 탭의 카테고리 숨김 토글은 dc_settings.cat_order 에 {off, order} 로
   저장되는데, 사이트는 그걸 안 읽고 위 HIDE 를 봤다. 지금은 두 값이 우연히
   같아(off = Custom Banners, Best Sellers) 잘 돌아가는 것처럼 보이지만, 다른 카테고리를
   숨기도록 바꿔도 사이트는 그대로였다.

   지금 하는 일
   -----------
   dc_settings 의 cat_order 를 한 번 읽어 **off 를 숨길 목록으로, order 를 보일 순서로**
   쓴다. 네트워크가 안 되거나 행이 없으면 예전 HIDE 로 돌아간다 — 설정을 못 읽었다고
   가려야 할 것이 갑자기 드러나지는 않게.

   템플릿 자체는 그대로 남는다. All Templates 에도, 상품 필터에도 그대로 나오고
   사이드바로 들어가는 길만 없어진다. 숨길 카테고리가 이미 선택된 상태면(옆링크로 온
   경우) All Templates 로 되돌린다.

   data-cat 속성으로 맞춘다 — 건수가 바뀌거나 라벨 스타일이 바뀜도 안 깨진다.

   진단: window.__dcCatList (source: 'settings' | 'fallback', hidden, ordered) */
(function () {
  'use strict';

  var FALLBACK_HIDE = ['Custom Banners', 'Best Sellers'];

  var state = { source: 'fallback', hide: FALLBACK_HIDE.slice(), order: [], hidden: [], ordered: 0, why: '' };
  window.__dcCatList = state;

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  /* ---- 관리자 설정 읽기 ---- */

  function loadSettings() {
    var sb = window.__dcSupabase;
    if (!sb || !sb.url || !sb.anonKey) { state.why = 'no supabase handle'; return; }
    fetch(sb.url + '/rest/v1/dc_settings?select=key,value&key=eq.cat_order', {
      headers: { apikey: sb.anonKey, Authorization: 'Bearer ' + sb.anonKey }
    })
      .then(function (r) { return r.json(); })
      .then(function (rows) {
        if (!Array.isArray(rows) || !rows.length) { state.why = 'no cat_order row'; return; }
        var v = rows[0].value;
        if (typeof v === 'string') { try { v = JSON.parse(v); } catch (e) { v = null; } }
        if (!v || typeof v !== 'object') { state.why = 'bad value'; return; }
        if (Array.isArray(v.off)) { state.hide = v.off.slice(); state.source = 'settings'; }
        if (Array.isArray(v.order) && v.order.length > 1) state.order = v.order.slice();
        sweep();
      })
      .catch(function (e) { state.why = 'fetch failed: ' + (e && e.message); });
  }

  /* ---- 숨김 ---- */

  function sweep() {
    var list = document.querySelector('#sbdt-root .sbdt-catlist');
    if (!list) return;

    var items = list.querySelectorAll('li[data-cat]');
    for (var i = 0; i < items.length; i++) {
      var name = items[i].getAttribute('data-cat');
      if (!name || norm(name) === 'all') continue;
      var drop = false;
      for (var j = 0; j < state.hide.length; j++) if (norm(state.hide[j]) === norm(name)) drop = true;

      /* 설정이 다시 «보이기» 로 바뀌었으면 되돌린다 — 이 파일이 감춘 것만. */
      if (!drop) {
        if (items[i].dataset.sbdcHidden) {
          delete items[i].dataset.sbdcHidden;
          items[i].style.removeProperty('display');
          var k = state.hidden.indexOf(name);
          if (k >= 0) state.hidden.splice(k, 1);
        }
        continue;
      }
      if (items[i].dataset.sbdcHidden) continue;

      /* 그 칸에 서 있는 중이면 All Templates 로 반 걸음 물러난다 — 선택된 칸을
         그냥 감추면 이유 없이 걸러진 빈 화면이 남는다. */
      if (items[i].classList.contains('is-on') || items[i].getAttribute('aria-current')) {
        var all = list.querySelector('li[data-cat=""], li');
        if (all && all !== items[i]) all.click();
      }

      items[i].dataset.sbdcHidden = '1';
      items[i].style.setProperty('display', 'none', 'important');
      if (state.hidden.indexOf(name) < 0) state.hidden.push(name);
    }

    reorder(list);
  }

  /* ---- 순서 ---- */

  function reorder(list) {
    if (!state.order.length) return;
    var items = [].slice.call(list.querySelectorAll('li[data-cat]'));
    if (items.length < 2) return;

    var rank = {};
    for (var i = 0; i < state.order.length; i++) rank[norm(state.order[i])] = i;

    /* All Templates 는 항상 맨 위. 목록에 없는 카테고리는 지금 순서대로 뒤에. */
    var want = items.slice().sort(function (a, b) {
      var an = norm(a.getAttribute('data-cat')), bn = norm(b.getAttribute('data-cat'));
      if (an === 'all') return -1;
      if (bn === 'all') return 1;
      var ai = (an in rank) ? rank[an] : 900 + items.indexOf(a);
      var bi = (bn in rank) ? rank[bn] : 900 + items.indexOf(b);
      return ai - bi;
    });

    var same = true;
    for (var j = 0; j < items.length; j++) if (items[j] !== want[j]) { same = false; break; }
    if (same) return;

    for (var k = 0; k < want.length; k++) list.appendChild(want[k]);
    state.ordered++;
  }

  /* ---- 부팅 ---- */

  function start() {
    sweep();
    loadSettings();
    /* 상품 필터가 바뀜때마다 목록이 다시 그려지므로 계속 본다. */
    var t = setInterval(sweep, 500);
    var root = document.getElementById('sbdt-root');
    if (root && window.MutationObserver) {
      new MutationObserver(function () { sweep(); }).observe(root, { childList: true, subtree: true });
    }
    window.addEventListener('pagehide', function () { clearInterval(t); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
